import { useState, useEffect, useRef } from "react";
import Utils from "../utils";

const RowBook = ({ script, onBookClick }) => {
  const isSampleScript = Utils.isSampleScript(script)

  return <button type="button" className="home-book-row"
    onClick={() => onBookClick(script.scriptNo, isSampleScript)}
  >
    <img className="home-book-row-cover" src={(script.mainImageUrl + "?300")} alt="" loading="lazy" width="76" height="88" />
    <div className="home-book-row-copy">
      {isSampleScript && <span className="home-book-row-label">미리보기</span>}
      <h3>{script.title}</h3>
      <p>{script.summary}</p>
    </div>
    <span className="home-row-arrow" aria-hidden="true">›</span>
  </button>
}

const BookRowList = ({ scripts, onBookClick }) => {

  const PAGE_SIZE = 5
  const [page, setPage] = useState(1)
  const [maxPage, setMaxPage] = useState(1)
  const [touchStartX, setTouchStartX] = useState(null)
  const [pageLoading, setPageLoading] = useState(false)
  const pageLoadingRef = useRef(false)

  const getPageScripts = (pageNo) => {
    const from = (pageNo - 1) * PAGE_SIZE
    const to = from + PAGE_SIZE
    return scripts ? scripts.slice(from, to) : []
  }

  const preloadImages = (items) => {
    const imageUrls = items.map(script => script.mainImageUrl && script.mainImageUrl + "?300").filter(Boolean)
    if (imageUrls.length === 0) return Promise.resolve()

    return Promise.all(imageUrls.map(imageUrl => new Promise(resolve => {
      const image = new Image()
      image.onload = resolve
      image.onerror = resolve
      image.src = imageUrl
    })))
  }

  const movePage = async (targetPage) => {
    if (pageLoadingRef.current || targetPage === page) return

    pageLoadingRef.current = true
    setPageLoading(true)
    try {
      await preloadImages(getPageScripts(targetPage))
      setPage(targetPage)
    } finally {
      setPageLoading(false)
      pageLoadingRef.current = false
    }
  }

  const before = () => {
    if (pageLoading) return
    movePage(page === 1 ? maxPage : page - 1)
  }

  const next = () => {
    if (pageLoading) return
    movePage(page === maxPage ? 1 : page + 1)
  }

  useEffect(() => {
    if (!scripts || scripts.length === 0) return
    setMaxPage(Math.floor((scripts.length - 1) / PAGE_SIZE) + 1)
  }, [scripts])

  const from = (page - 1) * PAGE_SIZE
  const to = from + PAGE_SIZE

  const pagedScripts = scripts && scripts.slice(from, to)

  const onTouchStart = (e) => {
    if (pageLoading) return
    setTouchStartX(e.touches[0].clientX)
  }

  const onTouchEnd = (e) => {
    if (pageLoading) return
    if (touchStartX === null) return
    const diff = touchStartX - e.changedTouches[0].clientX
    if (Math.abs(diff) > 50) {
      if (diff > 0) {
        next()
      } else {
        before()
      }
    }
    setTouchStartX(null)
  }

  return <div className="home-book-rows" aria-busy={pageLoading} onTouchStart={onTouchStart} onTouchEnd={onTouchEnd}>
    {
      pagedScripts && pagedScripts.map(script => <RowBook key={script.scriptNo} script={script} onBookClick={onBookClick} />)
    }
    {
      pageLoading && <div className="absolute inset-0 z-10 flex items-center justify-center rounded-lg bg-new-black/40">
        <div className="rounded-xl bg-white p-4 shadow-lg">
          <img className="w-20" src="/image/loading_book.gif" alt="로딩중" />
        </div>
      </div>
    }
    {
      maxPage > 1 && <div className="home-book-pagination">
        <button type="button" onClick={before} disabled={pageLoading} aria-label="동화 이전 페이지"><span aria-hidden="true">‹</span></button>
        <span aria-live="polite" aria-atomic="true"><strong>{page}</strong> / {maxPage}</span>
        <button type="button" onClick={next} disabled={pageLoading} aria-label="동화 다음 페이지"><span aria-hidden="true">›</span></button>
      </div>
    }

  </div>
}

export default BookRowList
